'use strict';

module.exports = require('./Autosuggest').default;